import { Divider, Grid, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react'
import globalStyles from "../../../assets/styles/global.module.scss";
import style from "../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import { chatbotStatus, getChatbotListNewReponseModel } from '../../../models/axiosModel';
import Required from '../../utility/required';
import GlobalButton from '../../utility/globalButton/button';
import { WorkflowContext, WorkflowContextPayload } from '../../../context/workflowContext';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import agent from '../../../services/api';
import { getChatbotStatusInfo } from '../flowBuilder/flowBuilderConstants';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

interface PauseChatbotPopupProps {
    setFlagPauseChatbotPopup: React.Dispatch<React.SetStateAction<boolean>>, 
    selectedWorkflowData: getChatbotListNewReponseModel, 
    getExistingWorkflowList: () => Promise<void>,
}  

const PauseChatbotPopup: React.FC<PauseChatbotPopupProps> = (props) => {
    
    const { setFlagPauseChatbotPopup, selectedWorkflowData, getExistingWorkflowList } = props;
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload;
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload

    const { showSuccess, listOfChatbotStatus, getChatbotStatus } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess,
        listOfChatbotStatus: state.listOfChatbotStatus,
        getChatbotStatus: state.getChatbotStatus,
    })))

    const handlePauseChatbot = async () => { 
        setFlagLoading((prev) => ({...prev, flagRoundLoader: true})); 

        let chatbot_statuses: any = listOfChatbotStatus;

        if(!chatbot_statuses){
            chatbot_statuses = await getChatbotStatusApi(); 
            if(!chatbot_statuses){
                setFlagLoading(prev => ({ ...prev, flagRoundLoader: false }));
                return;
            }
        }

        const chatbot_id = selectedWorkflowData?.chatbot_id ?? ""; 
        const status_id = getChatbotStatusInfo(selectedWorkflowData)?.label?.toLowerCase() == "active" ? 
            chatbot_statuses?.find((status: any) => status.status_name?.toLowerCase() == "active")?.status_id ?? "" 
            : 
            chatbot_statuses?.find((status: any) => status.status_name?.toLowerCase() == "paused")?.status_id ?? "";
        
        const payload = {
            chatbot_status_id: status_id, 
        }

        const res = await agent.updateChatbotStatus.put(chatbot_id, payload);
        if(res.status){
            showSuccess(`Chatbot ${getChatbotStatusInfo(selectedWorkflowData)?.label} successfully.`)
            await getExistingWorkflowList();
        } else {
            handleError(res);
        } 
        setFlagPauseChatbotPopup(false);
        setFlagLoading((prev) => ({...prev, flagRoundLoader: false}));
    }

    const getChatbotStatusApi = async () => {
        const res = await getChatbotStatus(); 
        if(!(res.status)){
            handleError(res);
        } 
        return res?.data; 
    }
    
    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container className={`${globalStyles.flexColumn} ${globalStyles.justifyCenter}`}>
                        <Grid item className={globalStyles.textCenter}>
                            <Typography className={style.popupTitleTypography}>{`${getChatbotStatusInfo(selectedWorkflowData)?.label} Chatbot`}</Typography>
                        </Grid>

                        <Divider className={style.popupTitleDivider} />  

                        <Grid item className={globalStyles.fullwidth}>
                            <Grid container className={style.popupBodyGridContainer} gap={1}>
                                <Grid item xs={12}>
                                    <Typography className={`${globalStyles.primaryFontSize} ${globalStyles.secondaryFontWeight}`}>
                                        {`Are you sure want to ${getChatbotStatusInfo(selectedWorkflowData)?.label?.toLowerCase()} ${selectedWorkflowData?.chatbot_name} chatbot?`}
                                    </Typography>
                                </Grid> 

                                <Grid item xs={12}>
                                    <Grid container className={`${globalStyles.justifyCenter} ${globalStyles.alignItemCenter}`} gap={"12px"} sx={{ padding: "30px 0 10px 0" }}>
                                        <Grid item>
                                            <GlobalButton
                                                buttonText="Cancel"
                                                sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                                className='borderedButtonStyle'
                                                onClick={() => setFlagPauseChatbotPopup(false)}
                                            >
                                            </GlobalButton>
                                        </Grid>
                                        <Grid item>
                                            <GlobalButton
                                                buttonText={`${getChatbotStatusInfo(selectedWorkflowData)?.label}`}
                                                sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                                className='primaryButtonStyle'
                                                onClick={() => handlePauseChatbot()}
                                            >
                                            </GlobalButton>
                                        </Grid>
                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default PauseChatbotPopup
